import React, {FC} from 'react'
import { useQuery } from 'react-query'
import { getSelfCareById } from '../../../../modules/services/self-care.service'
import { getDetailTesti } from '../../../../modules/services/testimoni.service'

interface Props {
  id? : string

}

const TestimoniInfo: React.FC<Props> = ({id}) => {
  const {data, isLoading} = useQuery(['getTestimoniDetail', id], async () => await getDetailTesti(id))
  const {data: cycle} = useQuery(['getDetailSeflCare',data?.attributes?.cycle],async () => await getSelfCareById(data?.attributes?.cycle))
  const head = [
    {
      key : 'ID :',
      value:  `${data?.id}`
    },
    {
      key :  'Member Name :',
      value: `${data?.attributes?.member?.data?.attributes?.fullname}`
    },
    {
      key : 'Cycle :',
      value: `${cycle?.attributes?.name}`
    },
    {
      key : 'Testimoni :',
      value: `${data?.attributes?.testimoni}`
    }
    
  ]

  return (
    <div className='card-body p-9'>
      {!isLoading && 
        <div className='col d-flex flex-column gap-4'>
          {head.map((e) => (
            <div className='row mb-7'>
              <h4 className='col-lg-4 fw-bold text-muted fs-6'>{e.key}</h4>
              {
                !isLoading &&   <div className='col-lg-8'>
          
                {e.key === 'Image' ? <img  src={`${process.env.REACT_APP_IMAGE}${e.value}`}   /> :  <p className='fs-6 ms-8'>{e.value}</p> } 
              
               </div>
              }
            
            </div>
          ))}
        </div>
      }
      
    </div>
  )
}

export default TestimoniInfo
